import { FileDownloadService } from "@topline/services/fileDownloadService";
import { angularServicesNames } from "@topline/services/angularServicesNames";
import { ToasterService } from "@topline/services/toasterService";

(function (module) {
    "use strict";
    module.service("forecastReportService", [
        "AlertService",
        "toastr",
        FileDownloadService.componentName,
        angularServicesNames.$translate,
        ToasterService.componentName,
        "Upload",
        "$q",
        function (
            this: $TSFixMe,
            AlertService: AlertService,
            toastr: ng.toastr.IToastrService,
            fileDownloadService: FileDownloadService,
            $translate: ng.translate.ITranslateService,
            toasterService: ToasterService,
            Upload: $TSFixMe,
            $q: ng.IQService
        ) {
            var service = this;
            service.downloadReport = (entity: $TSFixMe) => {
                toasterService.showReportGenerateBusyIndicator(
                    () => fileDownloadService.downloadFile("/api/report/masterPL/forecast/" + entity.id, "Master_PL"),
                    "FORECAST_LIST.GENERATING_PL_REPORT",
                    "FORECAST_LIST.PL_RAPORT_GENERATED"
                );
            };

            service.downloadMarketReport = (filters: $TSFixMe) => {
                toasterService.showReportGenerateBusyIndicator(
                    () => fileDownloadService.downloadFile("/api/report/masterPL/markets/", "Master_PL", filters),
                    "FORECAST_LIST.GENERATING_PL_REPORT",
                    "FORECAST_LIST.PL_RAPORT_GENERATED"
                );
            };

            service.importReportToML = function (file: $TSFixMe, errFiles: $TSFixMe) {
                if (file) {
                    var toast = toasterService.showReportGeneratingToast(
                        "FORECAST_LIST.IMPORTING_MASTER_PL_EXFACTORY_TO_ML"
                    );
                    file.upload = Upload.upload({
                        url: "api/import/masterPAndL/exFactory",
                        data: { file: file }
                    });

                    file.upload.then(
                        function (response: $TSFixMe) {
                            toastr.clear(toast);
                            AlertService.success(
                                $translate.instant("FORECAST_LIST.MASTER_PL_EXFACTORY_TO_ML_IMPORTED", {
                                    skuCount: response.data
                                })
                            );
                        },
                        function (response: $TSFixMe) {
                            toastr.clear(toast);
                        }
                    );
                }
            };

            service.changeProductCodes = (file: $TSFixMe) => {
                if (file) {
                    file.upload = Upload.upload({
                        url: "api/forecast/changeProductCodes/parse",
                        data: { file: file }
                    });

                    return file.upload.then((response: $TSFixMe) => response.data);
                } else {
                    $q.when({});
                }
            };

            service.downloadChangeProductCodesFileTemplate = () => {
                toasterService.showReportGenerateBusyIndicator(
                    () =>
                        fileDownloadService.downloadFile("api/forecast/changeProductCodes", "ChangeProductCodes.xlsx"),
                    "MARKET.GENERATE_TEMPLATE",
                    "MARKET.TEMPLATE_GENERATED"
                );
            };
        }
    ]);
})(angular.module("topline.modules"));
